import { Injectable, Output, EventEmitter } from "@angular/core";
import { Observable } from "rxjs";
import { AppUrlsService } from "src/app/modules/shared/services/app-urls.service";
import { AppHttpClient } from "src/app/modules/shared/services/http-client.service";
import * as jspdf from "jspdf";
import "jspdf-autotable";
import { DateTimePipe } from "src/app/modules/core/pipes/date-time.pipe";
import { environment } from "src/environments/environment";
import { HttpClient, HttpHeaders, HttpResponse } from "@angular/common/http";

@Injectable()
export class DeepLearningDataService {
  // private domain = `${this.appUrlsService.DOMAIN}`;
  private domain = `${environment.DOMAIN}`;
  private domainICT = `https://iot.dev.onstak.io/services/igt`;
  //private domain="http://192.168.11.19:8080/concillium-things-manager-service-v1/";
  private urls = {
    get: `${this.domain}/api/v1/things`,
    getAll: `${this.domain}/api/v1/things`,
    create: `${this.domain}/api/v1/things`,
    update: `${this.domain}/api/v1/things`,
    delete: `${this.domain}/api/v1/things`,
    exists: `${this.domain}/api/v1/things`,
    ffcurl: `http://10.39.115.193:5000/ffc`,
    imagepath: `http://10.39.110.86:5000/intruder`,
    AllAttribute: `${this.domain}/api/v1/attributes`,
    attributeupdate: `${this.domain}/api/things/createattributevalues`,
    thingAttributre: `${this.domain}/api/v1/things`,
    thingCreateAttributre: `${this.domain}/api/v1/attributes/values`,
    thingUpdateAttributre: `${this.domain}/api/v1/attributes/values`,
    getAllSubjects: `${this.domain}/api/v2/employee-profiles/allSubjects`,
    getFrCategories: `${this.domain}/api/v2/employee-profiles/getFrCategories`,
    dummy: `api/thingmanger`,
    kpilink: `http://10.39.110.86:5000/intruder/db`,
    //instrusionSave: "http://10.39.115.173:80/api/data_1/create",
    instrusionSave: "http://10.39.115.173/api/data_1/create",
    allIntrusionList: "http://10.39.115.173:80/api/data_1/getAll",
    removeIntrusion: "http://10.39.115.173:80/api/data_1/delete",
    ////
    getAllIntruderURl: `${this.domainICT}/api/v1/intruders/data_set`,
    getImageByURL: `${this.domainICT}/api/v1/image_analytics/images/query`,
    getAllEnterExitURl: `${this.domainICT}/api/v1/vehicle_stats/data_set`,
    getlprURl: `${this.domainICT}/api/v1/lpr`,
    maskdetection: `${this.domain}/api/v2/video-events/query`,
    queryEvent: `${this.domain}/api/v2/video-events/query`,
    cameraURL: `${this.domain}/api/v2/cameras`,
    deepLearningModelUrl: `${this.domain}/api/v2/dl-models`,
    deepLearningModels: `${this.domain}/api/v2/map-dl-models`,
    CamerFeedUrl: `${this.domain}/api/v2/cameras`,
    CamerFeedUrlWithImage: `${this.domain}/api/v2/cameras/getWithImage`,

    filebucketUrl: `${this.domain}/api/v2/video-events/sign-url`,
    getAllUser: `${this.appUrlsService.IDENTITY_LINK}/api/v2/users`,
    personUrl: `${this.domain}/api/v2/employee-profiles`,
    createRoi: `${this.domain}/api/v2/rois`,
    createChannelUrl: `${this.domain}/api/v2/notification-channels`,
    createNotificationChannelsUrl: `${this.domain}/api/v2/notification-camera-dlmodel`,
    updateNotificationChannelsUrl: `${this.domain}/api/v2/notification-camera-dlmodel`,
    updateEventsStatus: `${this.domain}/api/v2/video-events/status`,

    deleteChannelUrl: `${this.domain}/api/v2/notification-channels`,
    cameraImageCDN: `${this.domain}/cdn/cameras/images`,
    noticationLevelUrl: `${this.domain}/api/v2/notification-levels`,
    notificationChannelTypes: `${this.domain}/api/v2/notification-channel-types`,
    // allModelsUrl: `${this.domain}/api/v2/dl-models`,
    allMapDLModelsUrl: `${this.domain}/api/v2/map-dl-models`,
    getKafka: `${this.domain}/api/v2/va-video-alerts`,

    notificationModelURL: `${this.domain}/api/v2/notification-camera-dlmodel`,
    ciscoSnapshotUrl: `${this.domain}/api/v2/integration-detail/image`,
    groupsUrl: `${this.domain}/api/v2/groups`,
    cameraWithoutROIURl: `${this.domain}/api/v2/cameras/cameraroi`,
    videoEventsByTenant: `${this.domain}/api/v2/video-events/query/tenantbase`,
    // getCamImageUrl: `${this.domain}/api....`
    getEmailAlert: `${this.domain}/api/v2/video-events`,
    getModelCountDetail: `${this.domain}/api/v2/video-events/alerts/modelsCounts`,
  };

  public allTableData = `${this.domain}/api/v2/video-events/query`;

  constructor(
    private http: AppHttpClient,
    private httpClient: HttpClient,
    private appUrlsService: AppUrlsService,
    // private _DateTime: DateTimePipe,
  ) {}

  getVideoEventsCountByTenant(query) {
    return this.http.post(this.urls.videoEventsByTenant, query);
  }
  getModelsDetail(query) {
    return this.http.post(this.urls.getModelCountDetail, query);
  }

  getAllSubjects() {
    return this.http.get(this.urls.getAllSubjects);
  }
  getFrCategories() {
    return this.http.get(this.urls.getFrCategories);
  }
  getCloudFullDetails(obj) {
    return this.http.post(
      environment.DOMAIN + "/api/v2/video-events/query",
      obj,
    );
  }
  getVideoEventsCount(query: any) {}
  getCamerasWithQuery(pno, psize, search) {
    if (search != undefined) {
      return this.http.get(
        this.urls.cameraURL +
          "?pageNo=" +
          pno +
          "&pageSize=" +
          psize +
          "&search=" +
          search,
      );
    } else {
      return this.http.get(
        this.urls.cameraURL + "?pageNo=" + pno + "&pageSize=" + psize,
      );
    }
  }
  getCamerasWithoutROI() {
    return this.http.get(this.urls.cameraWithoutROIURl);
  }

  getAllGroups() {
    return this.http.get(this.urls.groupsUrl);
  }
  getGroupsWithQuery(pno, psize, search) {
    if (search != undefined) {
      return this.http.get(
        this.urls.groupsUrl +
          "?pageNo=" +
          pno +
          "&pageSize=" +
          psize +
          "&search=" +
          search,
      );
    } else {
      return this.http.get(
        this.urls.groupsUrl + "?pageNo=" + pno + "&pageSize=" + psize,
      );
    }
  }
  createGroups(data: any) {
    return this.http.post(this.urls.groupsUrl, data);
  }
  deleteGroup(id: any) {
    return this.http.delete(this.urls.groupsUrl + "/" + id);
  }
  updateGroups(id: any, data: any) {
    return this.http.put(this.urls.groupsUrl + "/" + id, data);
  }
  getGroupById(id: any) {
    return this.http.get(this.urls.groupsUrl + "/" + id);
  }
  getNetworkDeviceCiscoSnapshot(data: any) {
    return this.http.post(this.urls.ciscoSnapshotUrl, data);
  }
  getNotificationModel() {
    return this.http.get(this.urls.notificationModelURL);
  }
  createRoi(data) {
    return this.http.post(this.urls.createRoi, data);
  }
  createChannel(data) {
    return this.http.post(this.urls.createChannelUrl, data);
  }
  createNotificationChannels(data) {
    return this.http.post(this.urls.createNotificationChannelsUrl, data);
  }
  updateNotificationChannels(id, data) {
    return this.http.put(
      this.urls.updateNotificationChannelsUrl + "/" + id,
      data,
    );
  }
  updateEventStatus(id, data) {
    return this.http.put(this.urls.updateEventsStatus + "/" + id, data);
  }
  deleteChannel(id) {
    return this.http.delete(this.urls.deleteChannelUrl + "/" + id);
  }
  getCameraFeed(id) {
    return this.http.get(`${this.urls.CamerFeedUrl}/${id}/monitor`);
  }
  getDeepLearningModelById(id) {
    return this.http.get(`${this.urls.deepLearningModelUrl}/${id}`);
  }
  getMapDeepLearningModelById(id) {
    return this.http.get(`${this.urls.allMapDLModelsUrl}/${id}`);
  }
  createAIModel(data) {
    return this.http.post(this.urls.deepLearningModelUrl, data);
  }
  updateAIModel(data, id) {
    return this.http.put(this.urls.deepLearningModelUrl + "/" + id, data);
  }
  getAllDeepLearningModel() {
    return this.http.get(this.urls.deepLearningModelUrl);
  }
  getAllMapDLModels() {
    return this.http.get(this.urls.allMapDLModelsUrl);
  }
  getkafkaResp() {
    return this.http.get(this.urls.getKafka);
  }
  getAllDLModels() {
    return this.http.get(this.urls.deepLearningModels);
  }
  getAllSystemUser() {
    return this.http.get(this.urls.getAllUser);
  }
  getAllThingAttribute(id) {
    return this.http.get(
      `${this.urls.thingAttributre}/${id}/attributes/values`,
    );
  }
  getIntruderImage(image) {
    let obj = {
      query: [
        {
          action: "$eq",
          name: "imageName",
          value: image,
        },
      ],
    };
    return this.http.post(this.urls.getImageByURL, obj);
  }
  getMaskDetection(id) {
    let obj = {
      query: [
        {
          action: "$eq",
          name: "dlModelId",
          value: id,
        },
      ],
    };
    return this.http.post(this.urls.maskdetection, obj);
  }
  getDetailsWithPagination(id, pageSize, pageLength) {
    let obj = {
      pageNo: pageSize,
      pageSize: pageLength,
      query: [
        {
          action: "$like",
          name: "label",
          value: id,
        },
        {
          action: "$like",
          name: "value",
          value: "true",
        },
      ],
      order: [["id", "desc"]],
    };
    return this.http.post(this.urls.queryEvent, obj);
  }
  getDeepLearningModel(url, data, condition = false) {
    if (condition) {
      return this.http.post(this.domain + url, data);
    } else {
      return this.http.get(this.domain + url);
    }
  }
  getRequiredFile(name) {
    return this.http.get(`${this.urls.filebucketUrl}/${name}`);
  }
  getRequiredFileMultiple(data) {
    return this.http.post(`${this.urls.filebucketUrl}`, data);
  }
  getFullDetails(obj) {
    return this.http.post(this.urls.maskdetection, obj);
  }
  getAllIntruder() {
    return this.http.get(this.urls.getAllIntruderURl);
  }
  getAlllpr() {
    return this.http.get(this.urls.getlprURl);
  }
  getAllVehicleStat() {
    return this.http.get(this.urls.getAllEnterExitURl);
  }
  getAll() {
    return this.http.get(this.urls.getAll);
  }
  getAllKpiData(time, moniterId) {
    return this.http.getwityout(
      `${this.urls.kpilink}/${moniterId}/kpi_all?time=` + time,
    );
  }
  getFfc() {
    return this.http.getwityout(this.urls.ffcurl);
  }
  getAllAttribute() {
    return this.http.get(this.urls.AllAttribute);
  }
  getCamImage(data) {
    return this.httpClient.get(`${this.urls.cameraImageCDN}/${data}`, {
      responseType: "blob",
    });
  }
  getAllModels() {
    return this.http.get(this.urls.allMapDLModelsUrl);
  }
  getAllCamera() {
    return this.http.get(this.urls.CamerFeedUrl);
  }
  getAllCameraWithImage() {
    return this.http.get(this.urls.CamerFeedUrlWithImage);
  }
  getAllNotificationLevels() {
    return this.http.get(this.urls.noticationLevelUrl);
  }
  getAllNotificationChannelTypes() {
    return this.http.get(this.urls.notificationChannelTypes);
  }
  getAllPerson() {
    return this.http.get(this.urls.personUrl);
  }
  get(id: number) {
    return this.http.get(`${this.urls.get}/${id}`);
  }
  getemailAlert(id: any) {
    return this.http.get(`${this.urls.getEmailAlert}/${id}`);
  }
  getCamera(id: number) {
    return this.http.get(`${this.urls.cameraURL}/${id}`);
  }
  getimagepage() {
    return this.http.getwityout(`${this.urls.imagepath}`);
  }

  getIntruder(moniterId) {
    return this.http.getwityout(
      `${this.urls.imagepath}/${moniterId}/alert_add`,
    );
  }
  getIntruderInfo(moniterId) {
    return this.http.getwityout(
      `${this.urls.imagepath}/monitors/${moniterId}/info`,
    );
  }
  public getJSON(): Observable<any> {
    return this.http.get("./assets/routeone.json");
  }
  create(data) {
    return this.http.post(this.urls.create, data);
  }
  createAttributeValue(data) {
    return this.http.post(this.urls.thingCreateAttributre, data);
  }
  attributeupdate(data) {
    return this.http.post(this.urls.attributeupdate, data);
  }
  SaveIntrusin(data) {
    return this.http.postwithout(this.urls.instrusionSave, data);
  }
  update(data) {
    return this.http.put(this.urls.update, data);
  }
  updateAttribute(data) {
    return this.http.put(this.urls.thingUpdateAttributre, data);
  }
  delete(id: string) {
    return this.http.delete(`${this.urls.delete}/${id}`);
  }

  exists(data) {
    return this.http.post(this.urls.exists, data);
  }
  listofIntrusion() {
    return this.http.getwityout(this.urls.allIntrusionList);
  }
  deleteIntrusion(id: string) {
    return this.http.deleteWithou(`${this.urls.removeIntrusion}/${id}`);
  }
  @Output() value = new EventEmitter();
  UpdateValue(data) {
    this.value.emit(data);
  }

  videoEventsQuery(query: any) {
    return this.http.post(this.urls.queryEvent, query);
  }
  dashBoardGraphData(query: any, endpoint: any) {
    return this.http.post(`${this.domain}${endpoint}`, query);
  }
  videoEventsQueryForLastYear() {
    let query = {
      queryType: "timeseries",
      granularity: "year",
      order: "descending",
      aggregations: [
        {
          type: "filtered",
          filter: {
            type: "selector",
            dimension: "label",
            value: "faceMaskDetected",
          },
          aggregator: {
            type: "count",
            name: "faceMaskDetected",
            fieldName: "value",
          },
        },
        {
          type: "filtered",
          filter: {
            type: "selector",
            dimension: "label",
            value: "vehicleAlertDetected",
          },
          aggregator: {
            type: "count",
            name: "vehicleAlertDetected",
            fieldName: "value",
          },
        },
        {
          type: "filtered",
          filter: {
            type: "selector",
            dimension: "label",
            value: "socialDistancingViolation",
          },
          aggregator: {
            type: "count",
            name: "socialDistancingViolation",
            fieldName: "value",
          },
        },
        {
          type: "filtered",
          filter: {
            type: "selector",
            dimension: "label",
            value: "occupancydetected",
          },
          aggregator: {
            type: "count",
            name: "occupancydetected",
            fieldName: "value",
          },
        },
        {
          type: "filtered",
          filter: {
            type: "selector",
            dimension: "label",
            value: "crowdAlertDetected",
          },
          aggregator: {
            type: "count",
            name: "crowdAlertDetected",
            fieldName: "value",
          },
        },
        {
          type: "filtered",
          filter: {
            type: "selector",
            dimension: "label",
            value: "emotionsdetected",
          },
          aggregator: {
            type: "count",
            name: "emotionsdetected",
            fieldName: "value",
          },
        },
        {
          type: "filtered",
          filter: {
            type: "selector",
            dimension: "label",
            value: "ageGenderAlert",
          },
          aggregator: {
            type: "count",
            name: "ageGenderAlert",
            fieldName: "value",
          },
        },
        {
          type: "filtered",
          filter: {
            type: "selector",
            dimension: "label",
            value: "intruderAlertDetected",
          },
          aggregator: {
            type: "count",
            name: "intruderAlertDetected",
            fieldName: "value",
          },
        },
        {
          type: "filtered",
          filter: {
            type: "selector",
            dimension: "label",
            value: "facialRecognitionAlert",
          },
          aggregator: {
            type: "count",
            name: "facialRecognitionAlert",
            fieldName: "value",
          },
        },
        {
          type: "filtered",
          filter: {
            type: "selector",
            dimension: "label",
            value: "poseDetected",
          },
          aggregator: {
            type: "count",
            name: "poseDetected",
            fieldName: "value",
          },
        },
      ],
      postAggregations: [
        {
          type: "arithmetic",
          name: "total_count",
          fn: "+",
          fields: [
            {
              type: "fieldAccess",
              fieldName: "facialRecognitionAlert",
            },
            {
              type: "fieldAccess",
              fieldName: "poseDetected",
            },
            {
              type: "fieldAccess",
              fieldName: "intruderAlertDetected",
            },
            {
              type: "fieldAccess",
              fieldName: "ageGenderAlert",
            },
            {
              type: "fieldAccess",
              fieldName: "emotionsdetected",
            },
            {
              type: "fieldAccess",
              fieldName: "crowdAlertDetected",
            },
            {
              type: "fieldAccess",
              fieldName: "occupancydetected",
            },
            {
              type: "fieldAccess",
              fieldName: "socialDistancingViolation",
            },
            {
              type: "fieldAccess",
              fieldName: "vehicleAlertDetected",
            },
            {
              type: "fieldAccess",
              fieldName: "faceMaskDetected",
            },
          ],
        },
      ],
      intervals: [],
    };
  }
  videoEventsListQuery(mergeQuery: any, type: any) {
    let query: any = {
      order: "descending",
      intervals: mergeQuery.intervals,
      filter: mergeQuery.filter,
    };

    if (type == "count") {
      query.queryType = "timeseries";
      query.granularity = "all";
      query.aggregations = [{ type: "count", name: "Count" }];
    } else {
      query.queryType = "scan";
      query.limit = mergeQuery.limit;
      query.offset = mergeQuery.offset;
    }
    return this.http.post(this.urls.queryEvent, query);
  }

  getAllTableData(body) {
    return this.http.post(this.allTableData, body);
  }

  // For PDF
  getTodayDate() {
    let date = new Date();

    let month =
      date.getMonth() + 1 > 9
        ? date.getMonth() + 1
        : "0" + (date.getMonth() + 1);
    let day = date.getDate() > 9 ? date.getDate() : "0" + date.getDate();
    let year = date.getFullYear();

    return `${year}-${month}-${day}`;
  }

  WN_deepValue(string: string, from: object) {
    return string.split("..").reduce((r, val) => {
      return r ? r[val] : undefined;
    }, from);
  }

  async getPDF(report) {
    return new Promise(async (resolve) => {
      var doc: any = new jspdf.jsPDF();

      let values: any = [];
      let totalEmployes = 0,
        totalGuests = 0;
      let from = "";
      let to = "";
      let index = 0;
      let images = [];

      // report['body'].forEach(element => {
      for (let element of report["body"]) {
        let temp = [];

        for (let e of report["keys"]) {
          if (e == "videoTimestamp") {
            if (element[e]) {
              // let dateTime = this._DateTime.transform(element[e]);
              // temp.push(dateTime);
            } else {
              temp.push("----");
            }

            // from = this._DateTime.transform(element[e], 'mediumDate');
          }
          // else if( e == 'updated' ){

          //   if( element[e] ){

          //     let dateTime = this._DateTime.transform( element[e] );
          //     temp.push(dateTime);

          //   }
          //   else{
          //     temp.push('----')
          //   }

          //   if( index == 0 ) to = this._DateTime.transform(element[e], 'mediumDate');
          //   index++;

          // }
          // else if( e == 'totalAmount' ){

          //   if( element[e] ){

          //     let numberValue = this._DecimalPipe.transform( element[e], '1.0-2' );
          //     temp.push(numberValue);

          //   }
          //   else{
          //     temp.push('----')
          //   }

          // }
          // else if( e == 'discountAmount' ){

          //   if( element[e] ){

          //     let numberValue = this._DecimalPipe.transform( element[e], '1.0-2' );
          //     temp.push(numberValue);

          //   }
          //   else{
          //     temp.push('----')
          //   }

          // }
          else {
            // temp.push( element[e] ? element[e] : '' );
            temp.push(element[e] ? element[e] : this.WN_deepValue(e, element));
          }
        }

        values.push(temp);
      }

      console.log(from, to);

      // try{
      //   doc.addImage( await this.getImageFromUrl('assets/images/haji-sons.png'), 'PNG', 14, 10, 50, 18);
      // }
      // catch ( exc ) {}

      doc.text(report["name"], 14, 35);
      doc.setFontSize(8);
      // doc.text("Date : " + this.datePipe.transform(new Date(), "medium"), 14, 40)

      let titles = report["titles"].slice();
      let autoTableConfigurations: any = {
        startY: 50,
        head: [titles],
        body: values,
        tableWidth: "100%",
      };

      doc.autoTable(autoTableConfigurations);

      let finalY = doc.previousAutoTable.finalY;
      doc.text("This is system generated report.", 14, finalY + 5);

      let ts = Math.round(new Date().getTime() / 1000);
      let filename = "Report_" + ts + ".pdf";

      doc.save(filename);
      resolve(true);
    });
  } // pdf end
}
